/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowGardenPartyTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowGardenParty,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Celebrate in the Garden!",
    "Spring Fling Awaits!",
    "Garden Gathering Fun!",
  ],
  title: "Garden Party",
  description: "Organize a lovely garden party.",
  longDescription:
    "Gather your friends for a delightful garden party! Choose a date, plan the decorations, and decide on food and drinks!",
  emoji: "🌼",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Party,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Garden Party",
          emoji: "🌼",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we have the garden party?",
          emoji: "📅",
          completeAction: {
            question: "Decide on decorations for the garden?",
            description:
              "What decorations should we have for our garden party?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What decorations should we use?",
                emoji: "🎈",
                completeAction: {
                  question: "Decide on food and drinks?",
                  description:
                    "What food and drinks should we serve at the party?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What food should we prepare?",
                      emoji: "🥗",
                    },
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What drinks should we serve?",
                      emoji: "🍹",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Enjoy Your Garden Party!",
    outroDescription:
      "Your garden party plans are set! Enjoy the beautiful day!",
  },
};
